module.exports = __webpack_public_path__ + "static/media/OpenSans.cb8743d4.ttf";